export default __webpack_public_path__ + "media/images/icons/phone-solid-ac5f8fa5d547e0e8df54ef3369cff534.svg";